




























import { Component, Vue } from 'vue-property-decorator';
import { Store } from 'vuex';
import { readUserProfile } from '@/store/main/getters';

@Component
export default class UserProfile extends Vue {
  public containerClass = 'container page__container';

  get userProfile() {
    return readUserProfile(this.$store);
  }
}
